"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.eventTypes.conversation_analysis': 'Conversation Analysis',
    'webhook.eventTypes.avatar_updated': 'Avatar Updated',
    'webhook.eventTypes.avatar_deleted': 'Avatar Deleted',
    'webhook.eventTypes.avatar_test_complete': 'Avatar Test Complete',
    'webhook.eventTypes.knowledge_added': 'Knowledge Added',
    'webhook.eventTypes.knowledge_removed': 'Knowledge Removed',
    'webhook.eventTypes.knowledge_notify': 'Edit Knowledge',
};
